import { Navigate } from 'react-router'
import { useRole } from '@/auth/useRole'

/**
 * `/relaties` index: the fundraiser's home is the fund-leads connections board
 * (spec-54, the only CRM part they can reach); everyone else lands on the CRM
 * overview like before.
 */
export function RelatiesIndexRedirect() {
  const { role, loading } = useRole()
  if (loading) {
    return null
  }
  return (
    <Navigate
      to={role === 'fundraiser' ? '/relaties/fundraising/connecties' : '/relaties/overzicht'}
      replace
    />
  )
}
